/**
 * Active-workspace client state, readable OUTSIDE React (the data provider
 * runs in plain functions). The value mirrors the ra-core store entry written
 * by useWorkspaces / WorkspaceSelector.
 *
 * SECURITY NOTE: this is presentation scoping only. RLS enforces membership
 * on every query regardless of this value, a forged id yields zero rows.
 */
const STORE_KEY = "RaStoreCRM.gravun.activeWorkspaceId";

export const getActiveWorkspaceId = (): string | null => {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return typeof parsed === "string" && parsed.length > 0 ? parsed : null;
  } catch {
    return null;
  }
};

/** Tenant-owned resources whose queries are scoped to the active workspace. */
export const WORKSPACE_SCOPED_RESOURCES = new Set([
  "contacts",
  "contacts_summary",
  "companies",
  "companies_summary",
  "deals",
  "contact_notes",
  "deal_notes",
  "tags",
  "tasks",
  "activity_log",
  "custom_field_definitions",
  "jobs",
  "products",
  "estimates",
  "estimate_line_items",
  "invoices",
  "invoice_line_items",
  "payments",
  "appointments",
  "booking_pages",
  "sequences",
  "sequence_steps",
  "sequence_enrollments",
  "conversations",
  "messages",
  "integration_connections",
  "forms",
  "form_submissions",
  "review_requests",
  "segments",
  "campaigns",
  "campaign_recipients",
  "workflows",
  "workflow_actions",
  "workflow_runs",
  "workflow_run_steps",
  "calls",
  "message_templates",
  "contact_timeline",
  "task_checklist_items",
  "checklist_templates",
  "pipelines",
  "pipeline_stages",
]);
